module.exports = __webpack_public_path__ + "bin/602c9c5622dfb0bb95190a5f39f182d0.png";